import { createSelector } from 'reselect';

/**
 * Direct selector to the credentialTypeList state domain
 */
const selectCredentialTypeListDomain = (state) => state.get('credentialTypeList');

/**
 * Other specific selectors
 */

/**
 * Default selector used by CredentialTypeList
 */

const makeSelectCredentialTypeList = () => createSelector(
  selectCredentialTypeListDomain,
  (substate) => substate.toJS()
);

export default makeSelectCredentialTypeList;
export {
  selectCredentialTypeListDomain,
};
